<template>
  <span :class="classes">
    <slot/>
    <transition :name="transition">
      <span
        v-show="value"
        class="s-badge__wrapper">
        <span
          class="s-badge__badge"
          :style="styles">
          <slot name="content">
            <template
              v-if="content && !dot">{{ content }}
            </template>
            <sIcon
              v-else-if="icon"
              class="mx-auto my-auto"
              size="12"
              :type="icon"/>
          </slot>
        </span>
      </span>
    </transition>
  </span>
</template>
<script>
import sIcon from './icon'
import { convertToUnit, getSlot } from '../utils/util'

/**
 * Компонент "Badge"
 * @displayName Badge
 */
export default {
  name: 'sBadge',
  componentName: 'sBadge',
  methods: {
    calcPosition(offset) {
      return `calc(100% - ${convertToUnit(offset || this.offset)})`
    },
    genBadgeContent () {
      // Dot prop shows no content
      if (this.dot) { return undefined }

      const slot = getSlot(this, 'badge')

      if (slot) { return slot }
      if (this.content) { return String(this.content) }
      if (this.icon) { return this.$createElement(sIcon, this.icon) }

      return undefined
    },
    /* genBadgeWrapper () {
      return this.$createElement('span', {
        staticClass: 's-badge__wrapper',
      }, [this.genBadge()])
    },*/
  },
  computed: {
    classes() {
      return {
        's-badge': true,
        's-badge--bordered': this.bordered,
        's-badge--bottom': this.bottom,
        's-badge--dot': this.dot,
        's-badge--icon': this.icon != null,
        's-badge--inline': this.inline,
        's-badge--left': this.left,
        's-badge--overlap': this.overlap,
        's-badge--tile': this.tile
      }
    },
    computedBottom() {
      return this.bottom ? 'auto' : this.computedYOffset
    },
    computedLeft() {
      return this.left ? 'auto' : this.computedXOffset
    },
    computedRight() {
      return !this.left ? 'auto' : this.computedXOffset
    },
    computedTop() {
      return this.bottom ? this.computedYOffset : 'auto'
    },
    computedXOffset() {
      return this.calcPosition(this.offsetX)
    },
    computedYOffset() {
      return this.calcPosition(this.offsetY)
    },
    // Default fallback if offsetX
    // or offsetY are undefined.
    offset() {
      if (this.overlap) { return this.dot ? 8 : 12 }
      return this.dot ? 2 : 4
    },
    styles() {
      const color = this.color ? this.color : 'red'
      const textColor = this.textColor ? this.textColor : 'white'
      const colorStyle = `color: ${textColor}; background-color: ${color} !important; border-color: ${color} !important;`
      if (this.inline) { return colorStyle }

      return `${colorStyle} inset: ${this.computedTop} ${this.computedRight} ${this.computedBottom} ${this.computedLeft}; ${this.innerStyles}`
    },
  },
  components: {
    sIcon,
  },
  /* render(h) {
    const badge = [this.genBadgeWrapper()]
    const children = [getSlot(this)]
    const {
      'aria-atomic': _x,
      'aria-label': _y,
      'aria-live': _z,
      role,
      title,
      ...attrs
    } = this.$attrs

    if (this.inline && this.left) children.unshift(badge)
    else children.push(badge)

    return h('span', {
      staticClass: 's-badge',
      attrs,
      class: this.classes,
    }, children)
  }, */
  props: {
    /**
     * Применяет рамку шириной 2 пикселя по умолчанию и рамку шириной 1,5 пикселя вокруг значка при использовании свойства точки.
     */
    bordered: {
      type: Boolean,
    },
    /**
     * Применяет указанный цвет к элементу управления - это может быть название цвета материала (например, red или black) или цвет css (#033 или rgba(255, 0, 0, 0.5)).
     */
    color: {
      type: String,
      default: '#1976d2',
    },
    /**
     * Применяет указанный цвет к тексту и границе - это может быть название цвета материала (например, red или black) или цвет css (#033 или rgba(255, 0, 0, 0.5)).
     */
    textColor: {
      type: String,
      default: 'white',
    },
    /**
     * Любой контент, который вы хотите внедрить в виде текста в значок.
     */
    content: {
      type: [String, Number, Boolean],
      required: false
    },
    /**
     * Уменьшите размер значка и скройте его содержимое
     */
    dot: {
      type: Boolean,
    },
    /**
     * Обозначает конкретный значок, используемый в значке.
     */
    icon: {
      type: String,
    },
    /**
     * Перемещает значок, чтобы он был встроен в элемент упаковки. Поддерживает использование левой опоры.
     */
    inline: {
      type: Boolean,
    },
    /**
     * Смещение значка на x-axis.
     */
    offsetX: {
      type: [Number, String],
    },
    /**
     * Смещение значка на y-axis.
     */
    offsetY: {
      type: [Number, String],
    },
    /**
     * Перекрывает размещенное содержимое поверх компонента. (Не для Inline)
     */
    overlap: {
      type: Boolean,
    },
    /**
     * Удаляет радиус границы компонента.
     */
    tile: {
      type: Boolean,
    },
    left: {
      type: Boolean,
    },
    bottom: {
      type: Boolean,
    },
    /**
     * Это может быть один из встроенных переходов или ваш собственный.
     */
    transition: {
      type: String,
      default: 's-scale-rotate-transition',
    },
    /**
     * Определяет, будет ли компонент видимым или скрытым.
     */
    value: {
      type: [String, Number, Boolean],
      default: true
    },
    innerStyles: {
      type: String,
    },
  },
}
</script>
